import { shape, number, string } from 'prop-types';
import countryBasicInformationPropTypes from '../../../location/country/proptypes/CountryPropTypes';

const bankBasicInformationPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  swiftCode: string.isRequired,
  countryId: number.isRequired,
  country: shape(countryBasicInformationPropTypes),
};

export default bankBasicInformationPropTypes;
